var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.3198,
    height: 70.3198,
    rx: 35.1599,
    fill: "#DEAF91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.625 31.424C34.625 31.424 43.0961 24.9104 58.0254 30.5388C58.0021 30.5401 54.7229 30.7366 51.8992 35.1032C49.0749 39.4866 44.9637 52.1849 30.4283 47.3866C30.4012 47.4186 27.8217 50.4522 23.5507 51C23.5507 51 22.9993 49.9703 21.9336 49.1697C22.0059 49.1557 30.3119 47.5465 33.069 42.8902C33.069 42.8902 43.2143 32.0575 53.0576 31.0068C53.0576 31.0068 43.702 27.966 35.2797 33.2267L34.6227 31.4252L34.625 31.424ZM51.248 32.4279C38.7196 37.4893 32.6195 45.9147 32.6195 45.9147C43.1054 48.41 46.238 41.4605 48.3123 37.7588C50.3913 34.0583 51.248 32.4279 51.248 32.4279Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0601 19C24.1145 19.0365 35.6047 26.7628 33.6522 37.179C32.0821 45.5392 24.9635 46.5402 24.9361 46.544C24.9481 46.5106 30.1179 32.0303 25.3338 22.9039C25.3517 23.0028 27.64 35.7394 22.4961 45.192C22.4961 45.192 16.5143 42.0795 18.3501 33.924C20.1815 25.7659 25.8137 28.5473 24.0601 19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIconNew);
export default __webpack_public_path__ + "static/media/brand_icon_new.45f05ac147b4d6a80f72ee11e97ac655.svg";
export { ForwardRef as ReactComponent };